import { ChonkyIconFA } from "chonky-icon-fontawesome";
import { FullFileBrowser, ChonkyActions, setChonkyDefaults } from "chonky";
import React, { useCallback, useEffect, useState, useRef } from "react";
// import handleAction from "./chonkyActionHandler";
import { customActions } from "./chonkyCustomActions";
import vietNameseI18n from "./vietNameseI18n";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import fileManagerApi from "../../api/fileManagerApi";
import path from "path-browserify";
import Swal from "sweetalert2";
import { Image, Upload, message, Modal, Form, Input } from "antd";
import { getBase64Preview } from "../../utils/uploadImage";
import ENV from "../../consts/config";
import ReactPaginate from "react-paginate";

export default function ChonkyFile({ onSelected }) {
  const handleActionWrapper = (data) => {
    handleAction(data, setFolder);
  };
  setChonkyDefaults({ iconComponent: ChonkyIconFA });

  const [currentFolder, setCurrentFolder] = useState();
  const [folder, setFolder] = useState("/");
  const [prevFolder, setPrevFolder] = useState("/");

  const [fileData, setFileData] = useState([]);
  const [isModalPreview, setIsModalPreview] = useState(false);
  const [imageUpload, setImageUpload] = useState();

  // const fileActions = [...customActions, ChonkyActions.DownloadFiles];
  const fileActions = [...customActions];

  const [nameFile, setNameFile] = useState();
  const [form] = Form.useForm();

  const [totalDocuments, setTotalDocuments] = useState(1000);
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 50;
  const [currentPage, setCurrentPage] = useState(1 - 1);

  useEffect(() => {
    if (folder !== prevFolder) {
      getFiles(folder, 1);
      setCurrentPage(1 - 1);
      setPrevFolder(folder);
    } else {
      getFiles(folder, pageNumber);
    }
    form.setFieldsValue(nameFile);
  }, [folder, nameFile, pageNumber]);

  // useEffect(() => {
  //   getFiles(folder, 1);
  //   setCurrentPage(1 - 1);
  //   form.setFieldsValue(nameFile);
  // }, [folder]);

  const getFiles = (path, pageNumber) => {
    const params = {
      folderPath: path,
      limit: pageSize,
      page: pageNumber,
      sortBy: "createdAt:desc",
    };
    fileManagerApi.getFilesV2(params).then(
      (res) => {
        if (res?.results?.length > 0) {
          const data = res?.results;
          const folders = data.filter((a) => a.isDir);
          const medias = data.filter((a) => !a.isDir);
          const sortFolders = folders.sort((a) => a.name);
          const sortMedias = medias.sort((d1, d2) => new Date(d2.modDate) - new Date(d1.modDate));
          // const data = sortFolders.concat(sortMedias);
          setFileData([...sortFolders, ...sortMedias]);

          setTotalDocuments(res?.totalResults);
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: "",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const folderChain = React.useMemo(() => {
    let folderChain;
    if (folder === "/") {
      folderChain = [];
    } else {
      let currentPrefix = "";
      folderChain = folder
        .replace(/\/*$/, "")
        .split("/")
        .map((prefixPart) => {
          currentPrefix = currentPrefix ? path.join(currentPrefix, prefixPart) : prefixPart;
          return {
            id: currentPrefix + "/",
            name: prefixPart,
            isDir: true,
          };
        });
    }
    folderChain.unshift({
      id: "/",
      name: "Vnfarm",
      isDir: true,
    });
    return folderChain;
  }, [folder]);

  const thumbnailGenerator = (file) => {
    const folderPath = folder === "/" ? "" : folder;

    if (!file.isDir) {
      return `${ENV.CDN_URL}${folderPath}${file.name}`;
    }
  };

  const handleAction = (data, setFolder) => {
    if (data.id === ChonkyActions.OpenFiles.id) {
      if (data.payload.targetFile?.isDir) {
        setFolder(data.payload.targetFile?.id);
      }
    }

    if (data.id === "create_files") {
      setIsModalNewFolder(true);
      // const folderName = prompt("Provide the name for your new folder:");
      // if (folderName) {
      //   setFolder(`${folder}${folderName}/`);
      // }
    }
    if (data.id === "edit_files") alert("Edit Folder Action");
    if (data.id === "rename_files") renameFiles(data);
    if (data.id === ChonkyActions.UploadFiles.id) uploadFile();
    if (data.id === ChonkyActions.DownloadFiles.id) alert("Download Folder Action");
    if (data.id === ChonkyActions.DeleteFiles.id) alert("Delete Folder Action");
    if (data.id === "remove_files") removeFiles(data);
    if (data.id === "view") viewFiles(data);
    if (data.id === "select") selectFile(data);
  };

  //Add new folder
  const [isModalNewFolder, setIsModalNewFolder] = useState(false);

  const onFinishNewFolder = (data) => {
    if (data.folderName) {
      setFolder(`${folder}${data.folderName}/`);
      setIsModalNewFolder(false);
    }
  };

  const closePopupNewFolder = useCallback(() => {
    form.resetFields();
    setIsModalNewFolder(false);
  }, [form]);

  //#region select image
  const selectFile = (data) => {
    const folderPath = folder === "/" ? "" : folder;
    const fileName = data.state.contextMenuTriggerFile?.name || data.state.selectedFiles[0].name;
    const url = `${folderPath}${fileName}`;
    //dispatch(fileManagerActions.setUrlImageUp(url));
    onSelected(url);
  };
  //#endregion

  //#region Rename

  const [isModalEditName, setIsModalEditName] = useState(false);

  const renameFiles = (data) => {
    const checkFileSelect = data.state.contextMenuTriggerFile || data.state.selectedFiles.length > 0;

    if (checkFileSelect) {
      const fileName = data.state.contextMenuTriggerFile?.name || data.state.selectedFiles[0].name;

      const isFolder = data.state.contextMenuTriggerFile?.isDir || data.state.selectedFiles[0].isDir;

      setNameFile({
        fileOld: fileName,
        fileName: fileName,
        isFolder: isFolder,
      });
      setIsModalEditName(true);
    }
  };

  const closePopupEditName = useCallback(() => {
    setNameFile();
    form.resetFields();
    setIsModalEditName(false);
  }, [form, nameFile]);

  const onFinishFailedEditName = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinishEditName = (data) => {
    if (data.isFolder) {
      const folderPath = folder === "/" ? "" : folder;
      const folderName = `${folderPath}${data.fileOld}/`;
      const payload = {
        folderPath: folderName,
        newName: data.fileName,
      };
      fileManagerApi.renameFolder(payload).then(
        (res) => {
          if (res) {
            setNameFile();
            form.resetFields();
            setIsModalEditName(false);
            toast.success("Đổi tên thành công!", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              progress: undefined,
            });
          }
        },
        (err) => {
          console.log("err", err);
          toast.error("Đổi tên thất bại!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: undefined,
          });
        }
      );
    } else {
      const payload = {
        filePath: `${folder}${data.fileOld}`,
        newName: data.fileName,
      };
      fileManagerApi.renameFiles(payload).then(
        (res) => {
          if (res) {
            setNameFile();
            form.resetFields();
            setIsModalEditName(false);
            toast.success("Đổi tên thành công!", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              progress: undefined,
            });
          }
        },
        (err) => {
          console.log("err", err);
          toast.error("Đổi tên thất bại!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: undefined,
          });
        }
      );
    }
  };

  //#endregion

  //#region Remove File
  const removeFiles = (data) => {
    const isFolder = data.state.contextMenuTriggerFile?.isDir || data.state.selectedFiles[0].isDir;

    if (isFolder) {
      const fileId = data.state.contextMenuTriggerFile?.id || data.state.selectedFiles[0].id;
      const params = {
        folderPath: fileId,
      };

      fileManagerApi.removeFolder(params).then(
        (res) => {
          if (res) {
            getFiles(folder);
          }
        },
        (err) => {
          // console.log("err", err);
          Swal.fire({
            title: "Thất bại!",
            text: "",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      );
    } else {
      const fileName = data.state.contextMenuTriggerFile?.name || data.state.selectedFiles[0].name;

      const params = {
        files: folder + fileName,
      };

      fileManagerApi.removeFiles(params).then(
        (res) => {
          if (res) {
            console.log(res);
            getFiles(folder);
          }
        },
        (err) => {
          // console.log("err", err);
          Swal.fire({
            title: "Thất bại!",
            text: "",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      );
    }
  };
  //#endregion

  //#region View Files

  const [visible, setVisible] = useState(false);
  const [imageUri, setImageUri] = useState();

  const viewFiles = (data) => {
    const folderPath = folder === "/" ? "" : folder;
    const fileName = data.state.contextMenuTriggerFile?.name || data.state.selectedFiles[0].name;
    const url = `${ENV.CDN_URL}${folderPath}${fileName}`;
    setImageUri(url);
    setVisible(true);
  };
  //#endregion

  //#region Upload Image
  const [fileList, setFileList] = useState([]);

  const clickUpload = useRef(null);

  const uploadFile = () => {
    setFileList([]);
    clickUpload.current.click();
  };

  const onUpload = () => {
    const formData = new FormData();

    const folderPath = folder === "/" ? "" : folder;

    formData.append("file", imageUpload);
    formData.append("fileName", imageUpload.name);
    formData.append("path", folderPath);

    fileManagerApi.uploadFiles(formData).then(
      (res) => {
        if (res) {
          console.log(res);
          getFiles(folder);
          setIsModalPreview(false);
          toast.success("Tải lên thành công!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: undefined,
          });
        }
        return true;
      },
      (err) => {
        console.log("err", err);
        toast.error("Tải lên thất bại!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
      }
    );
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png" || (file.type === "image/svg+xml") | (file.type === "image/webp");

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG/SVG/WEBP file!");
      return false;
    }

    const isLt2M = file.size / 2048 / 2048 < 2;

    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
      return false;
    }

    onPreviewImage(file);

    return false;
  };

  const [isVisiblePreview, setVisiblePreview] = useState(false);
  const [imagePreview, setImagePreview] = useState();

  const onPreviewImage = (file) => {
    setImageUpload(file);
    getBase64Preview(file).then((res) => {
      setImagePreview(res);
    });

    setIsModalPreview(true);
  };
  //#endregion

  const handlePageClick = (data) => {
    const page = data.selected + 1;
    setPageNumber(page);
    setCurrentPage(data.selected);
  };

  return (
    <div>
      <div className="box-media" style={{ height: 650 }}>
        <FullFileBrowser
          thumbnailGenerator={thumbnailGenerator}
          files={fileData}
          folderChain={folderChain}
          defaultFileViewActionId={ChonkyActions.EnableListView.id}
          fileActions={fileActions}
          onFileAction={handleActionWrapper}
          disableDefaultFileActions={true}
          disableDragAndDrop={true}
          i18n={vietNameseI18n}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ReactPaginate
            pageCount={totalDocuments > 0 ? Math.ceil(totalDocuments / pageSize) : 1}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            previousLabel="Trang trước"
            nextLabel={"Trang sau"}
            forcePage={currentPage}
          />
        </div>
      </div>

      <div style={{ display: "none" }}>
        {/* <ImgCrop rotate aspect={100 / 100}>
          <Upload
            beforeUpload={beforeUpload}
            listType="picture-card"
            fileList={fileList}
            // customRequest={onChange}
            onChange={test}
          >
            <span ref={clickUpload}>Magic</span>
          </Upload>
        </ImgCrop> */}

        <Upload beforeUpload={beforeUpload} listType="picture-card" fileList={fileList}>
          <span ref={clickUpload}>Magic</span>
        </Upload>
      </div>
      <Modal
        title="Xem trước hình ảnh"
        visible={isModalPreview}
        onOk={onUpload}
        onCancel={() => {
          setIsModalPreview(false);
        }}
      >
        <Image
          width={"100%"}
          style={{ display: "block" }}
          src={imagePreview}
          preview={{
            isVisiblePreview,
            src: imagePreview,
            onVisibleChange: (value) => {
              setVisiblePreview(value);
            },
          }}
        />
      </Modal>

      <Image
        width={200}
        style={{ display: "none" }}
        src={imageUri}
        preview={{
          visible,
          src: imageUri,
          onVisibleChange: (value) => {
            // setImageUri(null);
            setVisible(value);
          },
        }}
      />
      <ToastContainer />

      <Modal title="Đổi tên" visible={isModalEditName} onOk={form.submit} onCancel={closePopupEditName}>
        <div>
          <Form initialValues={nameFile} form={form} name="basic" layout="vertical" onFinish={onFinishEditName} onFinishFailed={onFinishFailedEditName} autoComplete="off">
            <Form.Item hidden label="Tên tệp tin cũ" name="fileOld">
              <Input />
            </Form.Item>

            <Form.Item hidden label="Là thư mục" name="isFolder">
              <Input />
            </Form.Item>
            <Form.Item
              label="Tên tệp tin"
              name="fileName"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập tên!",
                },
              ]}
            >
              <Input placeholder="Nhập tên ..." />
            </Form.Item>
          </Form>
        </div>
      </Modal>

      <Modal title="Thư mục mới" visible={isModalNewFolder} onOk={form.submit} onCancel={closePopupNewFolder}>
        <div>
          <Form form={form} name="basic" layout="vertical" onFinish={onFinishNewFolder} autoComplete="off">
            <Form.Item
              label="Tên thư mục mới"
              name="folderName"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập tên thư mục!",
                },
              ]}
            >
              <Input placeholder="Nhập tên thư mục ..." />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
}
